import type { JSX } from "solid-js";

import { PictureWithMarks } from "../picture_with_marks";
import { photoRef, type PictureSlide as PictureSlideData, type PictureSrc } from "../types";

/** One picture filling the slide, or the part of it staff framed, with Pearl's marks over it and what they mean under
 *  it, and staff's pointers and words. */
export function PictureSlide(props: {
  slide: PictureSlideData;
  pictureSrc: PictureSrc;
  failedPictureText?: string;
}): JSX.Element {
  return (
    <>
      {/* The picture is the slide: its kind is said to a screen reader and printed in the caption under it. */}
      <h2 class="sr-only">{props.slide.headline}</h2>
      <PictureWithMarks
        picture={props.slide.picture}
        src={props.pictureSrc(photoRef(props.slide.picture))}
        failedText={props.failedPictureText}
        large
        frame={props.slide.frame}
        marks={props.slide.marks}
        notes={props.slide.notes}
        words={props.slide.words}
      />
    </>
  );
}
